import React from "react";
import { useSupplierModel } from "../supplierModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useSupplierModel();
    const {  getTreeSelectOne } = useDictModel(() => []);

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "供应商编码",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "供应商名称",
            fieldName: "name",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "联系人",
            fieldName: "contact",
        },
        {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "供应商类型",
            fieldName: "categoryCode",
            treeData: getTreeSelectOne(DictCodeEnmu.SUPPLIER_TYPE)
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: "状态",
        //     fieldName: "status",
        //     options: [{ label: "启用", value: "1" }, { label: "禁用", value: "0" }]
        // },
    ]

    return (
        <YhPageHeader
            title="供应商管理"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}